export default function Marquee() {
  const items = ["IGNITE LOVE","RESET TOGETHER","60-MINUTE SESSION","₹3,999 + 5% GST","ANDHERI WEST","SANTACRUZ WEST","BORIVALI WEST","ONLY 20 SLOTS"];
  const row = items.map((t, i) => (
    <span key={i} className="flex items-center gap-6 shrink-0">
      <span className="text-sm font-semibold tracking-[0.15em] text-[#bdb3a4] whitespace-nowrap">{t}</span>
      <span className="w-1.5 h-1.5 rounded-full bg-[#d7a85c]" />
    </span>
  ));
  return (
    <div className="py-5 bg-[#171310] border-y border-[rgba(242,207,139,0.18)] overflow-hidden">
      <div className="flex gap-6 animate-marquee" style={{ width: "max-content" }}>{row}{row}</div>
    </div>
  );
}
